// src/components/Admin1/Dashboard.jsx
import React, { useEffect } from 'react';
import Layout from '../Layout3';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Safreimg from '../../safreeimg/safree_icon.png'

const Admin3Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/admin3') {
      const timer = setTimeout(() => {
        navigate('/admin3/dashboard');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, navigate]);

  return (
    <div className='mylanding'>
      <Layout>
        {/* Conditional Rendering for Multiple Elements */}
        {location.pathname === '/admin3' && (
          <div className='welcomepage'>
            <img src={Safreimg} alt="" />
            <h1>Safree(Safe And Free)</h1>
            <p>Welcome to Guardian Admin!</p>
            {/* <NavLink
              to="/admin2/dashboard"
              className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
            >
              <button>Go TO Dashboard</button>
            </NavLink> */}
          </div>
        )}
      </Layout>
    </div>
  );
};

export default Admin3Dashboard;
